<div class="dialog-container" [@openState]="state">
  <div class="dialog">
    <div class="heading">
      <h2>Attacher une entité</h2>
      <t-icon name="close" class="close" (click)="close()" title="Fermer"></t-icon>
    </div>
    <div class="content filter">

      <div class="search">
        <input
          #searchInput
          type="text"
          placeholder="Recherche..."
          [(ngModel)]="search"
          (keyup)="searchKeyup($event)"
          autofocus />
        <button class="btn-search" (click)="apply()">
          <t-icon name="search"></t-icon>
        </button>
      </div>

      <ul *ngIf="state !== 'closed'" class="results">
        <li *ngFor="let entity of entities"
          [ngClass]="{ selected: entity === selectedItem }"
          (click)="select(entity)">
          {{ entity.name }}
        </li>
      </ul>

    </div>
  </div>
</div>